import { motion } from 'framer-motion'
import { ArrowDown } from 'lucide-react'
import { useT } from '../i18n/LanguageContext'

export default function Hero() {
  const t = useT()

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background effects */}
      <div className="absolute inset-0 bg-grid" />
      <div className="absolute inset-0 bg-radial-top" />
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-brand-600/[0.04] rounded-full blur-[120px]" />
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#050507] to-transparent" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center pt-32 pb-24">
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-light tracking-tight leading-[0.95] mb-8"
        >
          <span className="text-white">{t.hero.title1}</span>
          <br />
          <span className="text-white">{t.hero.title2}</span>
          <br />
          <span className="text-gradient-warm">{t.hero.title3}</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="text-lg sm:text-xl text-zinc-400 max-w-2xl mx-auto leading-relaxed mb-12"
        >
          {t.hero.subtitle}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <a
            href="#product"
            className="px-7 py-3.5 bg-brand-700 hover:bg-brand-600 text-white font-medium rounded-lg border border-white/[0.08] hover:border-white/[0.14] transition-all"
          >
            {t.hero.ctaPrimary}
          </a>
          <a
            href="#about"
            className="px-7 py-3.5 bg-white/[0.06] hover:bg-white/[0.1] text-zinc-300 hover:text-white border border-white/[0.1] hover:border-white/[0.16] font-medium rounded-lg transition-all"
          >
            {t.hero.ctaSecondary}
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.2 }}
          className="mt-20"
        >
          <a
            href="#about"
            className="inline-flex items-center gap-2 text-zinc-500 hover:text-zinc-300 text-sm transition-colors"
          >
            <ArrowDown size={16} className="animate-bounce" />
            {t.hero.scrollHint}
          </a>
        </motion.div>
      </div>
    </section>
  )
}
